import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {routeLink} from 'src/constant';
import {HttpAuthService} from 'src/services';
import {
  Section,
  Item,
  Text,
  Title,
  ItemTitle,
  Container,
  MainContainer,
  LoaderContainer,
} from './style/MedicationDetails.style';
import {handleNestedObjectAccess} from 'src/modules/alerts/screens/Utility';
import {TableHeader} from 'src/components/header/TableHeader';
import {sectionList} from '../constants/MedicationDetailsConfig';
import {ActivityIndicator} from '@unthinkable/react-activity-indicator';
import moment from 'moment';

const MedicationDetails = () => {
  const [medication, setMedication] = useState({});
  const [loading, setLoading] = useState(false);
  const {medicationId} = useParams();

  const fetchMedicationDetails = async () => {
    try {
      setLoading(true);
      const response = await HttpAuthService.get(
        `${routeLink.getMedication}/${medicationId}`,
        {
          params: {
            fields: {
              drugName: 1,
              drugId: 1,
              dose: 1,
              frequency: 1,
              direction: 1,
              fillDate: 1,
              quantity: 1,
              refillQuantity: 1,
              daysSupply: 1,
              pharmacyId: {
                name: 1,
                address: 1,
                city: 1,
                state: 1,
                zipCode: 1,
                phoneNumber: 1,
                faxNumber: 1,
              },
              prescriberId: {
                firstName: 1,
                lastName: 1,
                NPI: 1,
                phoneNumber: 1,
                faxNumber: 1,
              },
              prescriptionNumber: 1,
            },
          },
        },
      );
      setMedication(response?.data);
    } catch (err) {
      console.log('error:', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMedicationDetails();
  }, [medicationId]);
  if (loading) {
    return (
      <LoaderContainer>
        <ActivityIndicator />
      </LoaderContainer>
    );
  }
  return (
    <>
      <TableHeader title="Medication Details" />
      <MainContainer>
        {sectionList.map((section, index) => {
          return (
            <Section key={index}>
              <Title>{section.title}</Title>
              <Container>
                {section?.items?.map((item, index) => {
                  let value = handleNestedObjectAccess(medication, item.key);
                  if (item.type === 'date' && value) {
                    value = moment(value).format(item.format || 'DD/MM/YYYY');
                  } else if (item.type === 'date') {
                    value = '-';
                  }
                  return (
                    <Item key={index}>
                      <ItemTitle>{item.title}:</ItemTitle>
                      <Text>{value}</Text>
                    </Item>
                  );
                })}
              </Container>
            </Section>
          );
        })}
      </MainContainer>
    </>
  );
};

export default MedicationDetails;
